function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDistributor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 1497",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/distributor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 234",
    style: {
      fill: "none"
    },
    d: "M0 0h28v28H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1220",
    d: "M16563.451 13288.532h-6.969a1.153 1.153 0 0 1-1.162-1.142v-6.92l-2.322-4.03v-1.812a6.456 6.456 0 0 1 1.824-4.484 7.066 7.066 0 0 1 4.471-2.137h.635c.084 0 .258 0 .613-.007h.023a7.089 7.089 0 0 1 4.518 2.123 6.449 6.449 0 0 1 1.848 4.5v1.812l-2.324 4.023a.322.322 0 0 1 .006.073v6.854a1.155 1.155 0 0 1-1.161 1.147zm-4.066-4v1.146h1.16v-1.146h1.164v-1.135h-1.164v-1.146h-1.16v1.146h-1.158v1.135zm-4.914-8.091 1.711 3a1.056 1.056 0 0 1 .3-.041h6.969a1.373 1.373 0 0 1 .3.036l1.715-2.994h-10.994zm5.5-7.523a5.735 5.735 0 0 0-1.746 2.813 13.486 13.486 0 0 0-.457 3.785h4.4a13.318 13.318 0 0 0-.459-3.785 5.788 5.788 0 0 0-1.742-2.815z",
    transform: "translate(-16546.002 -13264.268)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDistributor);
export default __webpack_public_path__ + "static/media/iconDistributor.bc81a029.svg";
export { ForwardRef as ReactComponent };